fccd-header {
  .heading-section {
    text-align: center;
  }
}
